import * as z from "zod";

export const submitSpotCheckFeedback = {
  name: "submitSpotCheckFeedback" as const,
  input: z.object({
    conversationTopicId: z.string().regex(/^[\w-]{1,100}$/),
    channelThreadId: z.string().regex(/^[\w-]{1,100}$/),
    insightTitle: z.string().max(500),
    note: z.string().trim().min(1).max(4000),
  }),
  output: z.object({
    /** False when this environment has no feedback channel configured. */
    posted: z.boolean(),
  }),
};
